import { wencesApi } from "@/api/wencesApi";
import {
  SUPPORT_TICKET_FILE_INPUT_ACCEPT,
  SUPPORT_TICKET_MAX_FILE_BYTES,
  isSupportTicketAttachmentAllowed,
} from "@/utils/supportTicketUpload";

export const SUPPORT_ASSISTANT_MAX_PENDING_ATTACHMENTS = 5;

export const SUPPORT_ASSISTANT_FILE_ACCEPT = SUPPORT_TICKET_FILE_INPUT_ACCEPT;

export const SUPPORT_ASSISTANT_MAX_FILE_BYTES = SUPPORT_TICKET_MAX_FILE_BYTES;

export function isSupportAssistantAttachmentAllowed(file) {
  return isSupportTicketAttachmentAllowed(file);
}

/**
 * Sube a S3 y obtiene metadata + vista previa para la IA.
 * @param {File} file
 * @returns {Promise<{ fileKey: string, fileName: string, mimeType: string, size: number, textPreview?: string, uploadedAt?: string }>}
 */
export async function uploadAndPrepareSupportAssistantAttachment(file) {
  const formData = new FormData();
  formData.append("image", file);

  const uploadResponse = await wencesApi.post("/api/upload/upload", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

  const fileKey =
    uploadResponse.data &&
    (uploadResponse.data.fileKey || uploadResponse.data.data?.key);
  if (!fileKey) {
    throw new Error(
      (uploadResponse.data && uploadResponse.data.message) ||
        "No se recibió fileKey del servidor"
    );
  }

  const prep = await wencesApi.post("/api/support/assistant/prepare-attachment", {
    fileKey,
  });

  if (!prep.data || prep.data.success === false || !prep.data.attachment) {
    throw new Error(
      (prep.data && (prep.data.error || prep.data.message)) ||
        "No se pudo preparar el adjunto"
    );
  }

  return prep.data.attachment;
}

/**
 * Bloque de adjuntos en el mensaje usuario (alineado con telegramAiFileService).
 * @param {Array<{ fileKey: string, fileName?: string, mimeType?: string, textPreview?: string }>} attachments
 */
export function formatSupportAssistantAttachmentsUserBlock(attachments) {
  const list = Array.isArray(attachments) ? attachments : [];
  if (!list.length) return "";
  const lines = ["[Archivos disponibles en este chat]"];
  list.forEach((a, i) => {
    if (!a || !a.fileKey) return;
    const name = a.fileName || String(a.fileKey).split("/").pop() || "archivo";
    const mime = a.mimeType ? `, ${a.mimeType}` : "";
    lines.push(`${i + 1}. ${name}${mime}`);
    lines.push(`   fileKey: ${String(a.fileKey)}`);
    if (a.textPreview && String(a.textPreview).trim()) {
      const prev = String(a.textPreview).trim();
      lines.push("   contenido (vista previa):");
      lines.push(
        prev
          .split("\n")
          .map((ln) => `   ${ln}`)
          .join("\n")
      );
    }
  });
  lines.push(
    'Para adjuntar a un campo tipo "file" del registro: en item_modify/item_create usá exactamente ese fileKey como valor del campo (string; si isArray, array con el fileKey).'
  );
  return lines.join("\n");
}

export function buildUserMessageWithAttachments(text, attachments) {
  const t = String(text || "").trim();
  const block = formatSupportAssistantAttachmentsUserBlock(attachments);
  if (!block) return t;
  if (!t) return block;
  return `${t}\n\n${block}`;
}
